import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getCycleRecommendationQueryFn } from './queries/get-cycle-recommendation.query';
export const CycleRecommendationQueriesConfig = createQueriesConfig({
  getCycleRecommendation: {
    queryFn: getCycleRecommendationQueryFn
  }
});
//# sourceMappingURL=cycle-recommendation.queries.js.map